/* eslint-disable react/require-default-props */
import React from 'react';
import { Container } from './styles';

interface TextFilterProps {
  textFilterValue: string;
  setTextFilterValue: React.Dispatch<React.SetStateAction<string>>;
  placeHolder?: string;
}

const TextFilter = (props: TextFilterProps) => {
  const { textFilterValue, setTextFilterValue, placeHolder = 'Buscar' } = props;

  return (
    <Container className="p-0 mr-md-3 mr-0 my-3 my-md-0">
      <div className="input-group">
        <input
          type="text"
          value={textFilterValue}
          onChange={(event) => setTextFilterValue(event.target.value)}
          className="form-control border-right-0"
          placeholder={placeHolder}
        />
        <div className="input-group-append">
          <button
            className="btn btn-link btn-clean-search btn-sm"
            onClick={() => setTextFilterValue('')}
            type="button"
          >
            Limpar
          </button>
        </div>
      </div>
    </Container>
  );
};

export default TextFilter;
